module.exports = __webpack_public_path__ + "r-v3/img/ico_toast_success.4b4b8605.svg";